import { closest } from "./closest.js";
const closestViableBlockContainerEntry = (editor, options) => closest(editor, {
  at: options?.at,
  match: (node) => editor.canContainAnyBlocks(node)
});
export {
  closestViableBlockContainerEntry
};
//# sourceMappingURL=closestViableBlockContainerEntry.js.map
